import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IConnectionWithTotal, IDMDialogSpace } from '@api/types'
import { PageInfoFragment, DMDialogSpaceFragment } from '@api/fragments'

interface Payload {
  data: {
    node: {
      spaceConnection: IConnectionWithTotal<IDMDialogSpace>
    }
  }
}

export const departmentSpacesQuery = gql`
  query DepartmentSpaces($id: ID!, $first: Int, $after: String, $where: SpaceWhereInput) {
    node(id: $id) {
      ... on Department {
        spaceConnection(where: $where, first: $first, after: $after) {
          counters {
            total
          }
          pageInfo {
            ...PageInfoFragment
          }
          edges {
            node {
              ...DMDialogSpaceFragment
            }
          }
        }
      }
    }
  }
  ${PageInfoFragment}
  ${DMDialogSpaceFragment}
`

export default function spaces(variables: {
  departmentId: string
  first?: number
  after?: string
  query?: string
}): Promise<IConnectionWithTotal<IDMDialogSpace>> {
  const { departmentId, first = 5, query = '', after = '' } = variables

  return client.gql
    .query({
      query: departmentSpacesQuery,
      variables: {
        id: departmentId,
        first,
        after,
        where: {
          OR: [{ externalId_contains: query }, { name_contains: query }],
        },
      },
    })
    .then(({ data: { node } }: Payload) => node.spaceConnection)
}
